import { Component, OnInit, OnDestroy } from "@angular/core";
import { ExitSurveyService } from "../services/exit-survey.service";
import { ExitSurveyDetails } from "../exit-survey.interfaces";
import { ActivatedRoute, Params } from "@angular/router";
import * as moment from "moment";
const alertify = require("alertify.js");
import { Title } from '@angular/platform-browser';

const questionTypes = {
  "multi-choice": "Multiple Choice",
  "single-choice": "Single Choice",
  "free-text": "Free Text"
}

@Component({
  selector: "ch-exit-survey-details",
  templateUrl: "./exit-survey-details.component.html",
  styleUrls: ["./exit-survey-details.component.css"]
})
export class ExitSurveyDetailsComponent implements OnInit, OnDestroy {
  public surveyId: string;
  public surveyDetails: ExitSurveyDetails;

  public loading: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private exitSurveyService: ExitSurveyService,
    private titleService: Title,
  ) { }

  ngOnInit() {
    alertify.logPosition("bottom right");
    this.loadData();
  }

  ngOnDestroy() {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  loadData() {
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        this.surveyId = params.id;

        this.loading = true;
        this.exitSurveyService.getSurvey(this.surveyId).subscribe(
          data => {
            this.loading = false;
            this.surveyDetails = data.json();
            this.titleService.setTitle(`${this.surveyDetails.firstName} ${this.surveyDetails.lastName} | Exit Surveys | CODE Hospitality CMS`);
          },
          error => {
            this.loading = false;
            alertify.error(`Error loading survey details: ${error}`);
          }
        );
      });
  }

  get memberProfileLink() {
    return `admin/members/edit?id=${this.surveyDetails.userId}`
  }

  get cancelledAt() {
    return moment(this.surveyDetails.cancelledAt).format("DD MMM YYYY");
  }

  public questionType(question: string) {
    return questionTypes[question] || question;
  }

  get formattedSurveyData() {
    return JSON.stringify(this.surveyDetails, null, 2);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-details/exit-survey-details.component.ts